import { useState } from 'react'
import { Icon } from '../icons'

/**
 * Mercado Livre pre-sale questions are unlike every other channel in this inbox: the reply is
 * public and there is exactly one of it. No edit, no follow-up, no second try.
 *
 * The adapter already refuses a second answer, but a refusal after the agent has written and
 * sent something is a bad way to learn the rule. This states it before they type — and once the
 * question is answered, says so plainly rather than leaving a composer that looks usable.
 *
 * Uma linha, cortada com reticências, e o resto a um toque. No celular o texto inteiro ocupava
 * cinco linhas entre a pergunta e a resposta — empurrava as duas para fora da tela para avisar
 * sobre algo que se lê uma vez e se sabe para sempre. O que não pode sumir é a primeira frase,
 * e ela é justamente a que cabe.
 */
function Aviso({ tone, icon, titulo, resto }: { tone: string; icon: 'warn' | 'ck'; titulo: string; resto: string }) {
  const [aberto, setAberto] = useState(false)
  return (
    <div className="composer-zone" style={{ paddingBottom: 0, borderTop: 'none' }}>
      <div className="cz-inner">
        <button
          type="button"
          className={`ml-notice ${tone} ${aberto ? 'aberto' : ''}`}
          onClick={() => setAberto((v) => !v)}
          // No desktop o texto inteiro aparece no hover, sem gastar clique nenhum.
          title={`${titulo} ${resto}`}
          aria-expanded={aberto}
        >
          <Icon name={icon} size={14} />
          <span className="mln-txt">
            <strong>{titulo}</strong> {resto}
          </span>
          <Icon name="chev" size={12} />
        </button>
      </div>
    </div>
  )
}

export function MlQuestionNotice({ answered }: { answered: boolean }) {
  return answered ? (
    <Aviso
      tone="done"
      icon="ck"
      titulo="Pergunta já respondida."
      resto="O Mercado Livre aceita apenas uma resposta por pergunta — não é possível editar nem responder de novo."
    />
  ) : (
    <Aviso
      tone=""
      icon="warn"
      titulo="Resposta pública e única."
      resto="Ficará visível no anúncio para qualquer comprador, e o Mercado Livre permite apenas uma resposta — revise antes de enviar. Limite de 2.000 caracteres."
    />
  )
}
